export enum BackendMessageTemplateStatus {
  Active = 'active',
  InReview = 'in_review',
  Rejected = 'rejected',
  Draft = 'draft',
}
